/**
 * Dinheiro em CENTAVOS inteiros, sempre.
 *
 * Ponto flutuante em valor monetario produz balancete que nao fecha por
 * centavos - e um balancete que nao fecha destroi exatamente a transparencia
 * que o RF03.2 existe para dar.
 */

export function formatBRL(cents: number): string {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(cents / 100)
}

/** Sem o simbolo - para tabelas, onde a coluna ja diz que e dinheiro. */
export function formatAmount(cents: number): string {
  return new Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(cents / 100)
}

/**
 * Le o que o usuario digitou e devolve centavos. Aceita as formas que
 * aparecem na pratica: 1.234,56 / 1234,56 / 12 / 12.50 / com ou sem o simbolo.
 * Devolve null quando nao da para interpretar com seguranca.
 */
export function parseBRLToCents(input: string): number | null {
  const cleaned = input.replace(/[^0-9.,-]/g, '').trim()
  if (!cleaned) return null

  const hasComma = cleaned.includes(',')
  const hasDot = cleaned.includes('.')

  let normalized: string
  if (hasComma) {
    // Virgula e o separador decimal; ponto e separador de milhar.
    normalized = cleaned.replace(/\./g, '').replace(',', '.')
  } else if (hasDot) {
    // Sem virgula: um unico ponto com ate 2 casas e decimal (12.50);
    // qualquer outro arranjo e separador de milhar (1.234 / 1.234.567).
    const segments = cleaned.split('.')
    const last = segments[segments.length - 1] ?? ''
    normalized = segments.length === 2 && last.length <= 2 ? cleaned : cleaned.replace(/\./g, '')
  } else {
    normalized = cleaned
  }

  if (!/^-?\d+(\.\d+)?$/.test(normalized)) return null

  const value = Number(normalized)
  if (!Number.isFinite(value)) return null
  return Math.round(value * 100)
}

export function sumCents(values: readonly number[]): number {
  return values.reduce((acc, v) => acc + v, 0)
}
